import React from "react";
import logo from "../../../assets/لوگو 4.svg";
import { FaBars } from "react-icons/fa";
import { expertContext } from "../../../context/expertcontext";
import { useContext } from "react";
import { downloadUrl } from "../../../confing/confing";
const Header = () => {
  const { toggel, setToggel, page, exInfo } = useContext(expertContext);

  return (
    <div className="userpanel-header">
      <div>
        {exInfo?.pic && (
          <img
            src={`${downloadUrl}${exInfo.pic}`}
            alt="logo"
            width="50"
            height="50"
            style={{ borderRadius: "50%" }}
          />
        )}
        <strong className="me-2" style={{ fontSize: "18px" }}>
          {exInfo?.name}
        </strong>
      </div>
      <strong style={{ fontSize: "20px" }}>{page}</strong>
      <button
        className="btn"
        onClick={() => {
          setToggel(!toggel);
        }}
      >
        <FaBars />
      </button>
    </div>
  );
};

export default Header;
